import { getAllZenDeskTagsInArray } from "@faire/help-center-self-serve/utils/zenDeskTags";
import { getRetailerOrBrandCountry } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandCountry";
import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { ICreateTicketRequest } from "@faire/web-api--source/com/faire/vendor/zendesk/ICreateTicketRequest";
import createTicket from "@faire/web-api--source/endpoints/www/api/zendesk/create-ticket/post";
import { trackCxFoundationsTicketcreated } from "@faire/web-api--source/events/cxFoundations/actionCategoryOther/ticketcreated";
import { trackCxFoundationsLoggedOutSubmissionClick } from "@faire/web-api--source/events/cxFoundations/click/loggedOutSubmission";
import { QueryParameters as SupportQueryParams } from "@faire/web-api--source/routes/www/support";
import UAParser from "ua-parser-js";

import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";
import { useLoggedOutEmailContextStore } from "./LoggedOutEmailContextStore";
import { useLoggedOutContactUsNavigation } from "./useLoggedOutContactUsNavigation";
import { useLoggedOutIssueType } from "./useLoggedOutIssueType";
import { useLoggedOutUserType } from "./useLoggedOutUserType";

export const useLoggedOutEmailTicket = () => {
  const { goToNextStep } = useLoggedOutContactUsNavigation();
  const { issueType } = useLoggedOutIssueType();
  const { os_version, platform, app_version } = useQueryParams(
    SupportQueryParams.parse
  );

  const { isKnownUserType } = useLoggedOutUserType();
  const [{ user, issueL1 }] = useLoggedOutContactUsContextStore([
    "user",
    "issueL1",
  ]);
  const [
    { businessName, contactEmail, details },
    setLoggedOutEmailContextStore,
  ] = useLoggedOutEmailContextStore([
    "businessName",
    "contactEmail",
    "details",
  ]);

  const isLoggedOutSubmitDisabled = (): boolean => {
    return (
      !isKnownUserType || !issueL1 || !contactEmail || !businessName || !details
    );
  };

  const submitTicket = async (strictLocalize: StrictLocalizeFunction) => {
    try {
      const ua = new UAParser(navigator.userAgent).getResult();
      const platformValue = platform ?? ua.browser.name;
      const osVersionValue = os_version ?? `${ua.os.name} ${ua.os.version}`;
      const appVersionValue = app_version ?? ua.browser.version;

      trackCxFoundationsLoggedOutSubmissionClick();
      const ticketCreationPayload = ICreateTicketRequest.build({
        tags: getAllZenDeskTagsInArray(
          getRetailerOrBrandCountry() ?? "",
          user ?? "",
          issueType ?? ""
        ),
        email: contactEmail,
        name: businessName,
        subject: issueType,
        issue_type: issueType,
        description: details,
        platform: platformValue,
        os_version: osVersionValue,
        app_version: appVersionValue,
      });
      const customerToken = getRetailerOrBrandToken() ?? "";
      const zdResponse = await createTicket(ticketCreationPayload);
      trackCxFoundationsTicketcreated(
        (zdResponse.id ?? "").toString(),
        "",
        customerToken
      );
      goToNextStep();
    } catch (err) {
      setLoggedOutEmailContextStore({
        formErrorMessage: strictLocalize({
          defaultMessage: "Your request failed. Please retry again.",
        }),
      });
    }
  };
  return {
    submitTicket,
    isLoggedOutSubmitDisabled,
  };
};
